import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessSummaryEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-summary-embed',
	path: '/jira/core/projects/:projectKey/summary/embed',
	exact: true,
};
